// components/SubHeader.tsx
import { Box, Typography } from '@mui/material'
import React from 'react';

interface SubHeaderProps {
    title: string;
    children?: React.ReactNode; // for filters/actions
}

const SubHeader: React.FC<SubHeaderProps> = ({ title, children }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            // gap: '12px',
            // mb: '12px',
            px: '30px',
            pt: '30px',
        }}
    >
        <Typography
            variant="h4"
            sx={{
                fontSize: '22px',
                fontWeight: 600,
                color: '#1A202C',
                whiteSpace: 'nowrap',
            }}
        >
            {title}
        </Typography>

        {/* Optional filters or buttons */}
        {children && <Box sx={{ display: 'flex', gap: 2 }}>{children}</Box>}
    </Box>
);

export default SubHeader;
